import { useLocation } from 'react-router';
import { useEffect } from 'react';
import { Mixpanel } from 'src/tracking/mixpanel/Mixpanel';
import { MixpanelEvents } from 'src/tracking/mixpanel/MixpanelEvents';

export const PageViewTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const pathname = location.pathname;
    const title = document.title;

    // @ts-expect-error Exception where I need a string
    Mixpanel.track(`${MixpanelEvents.PAGE_VIEWED} - ${pathname}`, {
      page: title,
      path: pathname,
      timestamp: new Date().toISOString(),
    });
  }, [location]);

  return null;
};
